import { render, staticRenderFns } from "./PhoneParticipants.vue?vue&type=template&id=64ca9b6a&scoped=true&lang=pug"
import script from "./PhoneParticipants.vue?vue&type=script&lang=js"
export * from "./PhoneParticipants.vue?vue&type=script&lang=js"
import style0 from "./PhoneParticipants.vue?vue&type=style&index=0&id=64ca9b6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca9b6a",
  null
  
)

export default component.exports